import { ComponentProps, FC } from 'react'

import { twMerge } from '~/lib/utils'

import { InputError } from '../input-error'

type TextInputProps = {
  errorMessages?: React.ReactNode
} & ComponentProps<'input'>

export const TextInput: FC<TextInputProps> = ({
  className,
  errorMessages,
  ...props
}) => {
  return (
    <div className="flex flex-col gap-y-1">
      <input
        className={twMerge(
          'h-[52px] rounded border px-4 py-2 text-base outline-none placeholder:text-grayText',
          errorMessages
            ? 'border-2 border-alert'
            : 'border-grayBtn focus:border-2 focus:border-brand',
          className,
        )}
        type="text"
        {...props}
      />
      {errorMessages && (
        <InputError data-testid={`${props.name}-error`}>
          {errorMessages}
        </InputError>
      )}
    </div>
  )
}
